/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Tim_DescInputs */

const en_cp_p_tim_desc = /** @type {(inputs: Cp_P_Tim_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–9 teams, self-serve via QRIS/bank transfer. 2 PRDs & 30 agent messages per month, Pro features, Claude Opus 5, campus templates, lecturer as client.`)
};

const id_cp_p_tim_desc = /** @type {(inputs: Cp_P_Tim_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–9 tim, bayar sendiri lewat QRIS/VA. 2 PRD & 30 pesan agent per bulan, fitur Pro, Claude Opus 5, template kampus, dosen sebagai klien.`)
};

/**
* | output |
* | --- |
* | "1–9 teams, self-serve via QRIS/bank transfer. 2 PRDs & 30 agent messages per month, Pro features, Claude Opus 5, campus templates, lecturer as client." |
*
* @param {Cp_P_Tim_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_tim_desc = /** @type {((inputs?: Cp_P_Tim_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Tim_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_tim_desc(inputs)
	return en_cp_p_tim_desc(inputs)
});